(function () {
'use strict';

angular
    .module('grcEditRoutes', [
        'actionPlanEditRoutes',
        'actionPlanCriteriaEditRoutes',
        'controlEditRoutes',
        'committeeEditRoutes',
        'corporateRoleEditRoutes',
        'glossaryTermEditRoutes',
        'observationEditRoutes',
        'recommendationEditRoutes',
        'riskEditRoutes',
        'riskEventEditRoutes',
        'planInitiativeRoutes'
    ]);
})();